/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface UsageFeeLatestStatus
 */
export interface UsageFeeLatestStatus {
    /**
     * 
     * @type {string}
     * @memberof UsageFeeLatestStatus
     */
    'status': UsageFeeLatestStatusStatusEnum;
}

export const UsageFeeLatestStatusStatusEnum = {
    reserved: 'RESERVED',
    requestingExternalAccountTransfer: 'REQUESTING_EXTERNAL_ACCOUNT_TRANSFER',
    completed: 'COMPLETED',
    insufficientBalance: 'INSUFFICIENT_BALANCE',
    transferReceivable: 'TRANSFER_RECEIVABLE'
} as const;

export type UsageFeeLatestStatusStatusEnum = typeof UsageFeeLatestStatusStatusEnum[keyof typeof UsageFeeLatestStatusStatusEnum];


